<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>

      <template v-slot:isDefault="{ row }">
        <el-tag size="mini" :type="row.isDefault === 'Y' ? 'light' : 'info'">
          {{
            row.isDefault === 'Y'
              ? $l('INDEX.YES') || '是'
              : $l('INDEX.NO') || '否'
          }}
        </el-tag>
      </template>
      <template v-slot:ftyPrice="{ row }">
        {{ row.ftyPrice || '' }}
        {{ row.v_ftyPriceCurrencyUnit || '' }}
      </template>

      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_evg_sku_fty_view') || '查看'"
          placement="top"
        >
          <i
            class="el-icon-view tool-btn"
            @click="
              $emit('openEditFormDialog', {
                type: 'detail',
                code: row.evgSkuFtyCode,
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_evg_sku_fty_edit') || '编辑'"
          placement="top"
          v-show="!disabled"
        >
          <i
            class="el-icon-edit tool-btn"
            @click="
              $emit('openEditFormDialog', {
                type: 'edit',
                code: row.evgSkuFtyCode,
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_evg_sku_fty_del') || '删除'"
          placement="top"
          v-show="!disabled"
          v-if="row.isDefault === 'N'"
        >
          <i
            class="el-icon-delete tool-btn"
            @click="del(row.evgSkuFtyCode)"
          ></i>
        </el-tooltip>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns.js'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    loading: {
      default: false,
    },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    del(code) {
      this.$confirm(
        this.$l('INDEX.tips_evg_sku_fty_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_evg_sku_fty_delete_title') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.btn_evg_sku_fty_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_evg_sku_fty_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.ecomEvgSkuFtyDelApi({ evgSkuFtyCode: code }).then((res) => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_evg_sku_fty_ok') || res.msg,
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
  },
}
</script>
